import React from 'react';

const ServicesStory: React.FC = () => {
  return (
    <section className="container mx-auto px-4 py-12 sm:py-16">
      <div className="mx-auto max-w-3xl text-center">
        <h3 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-gray-900">
          A Tale of Resilience and Creativity
        </h3>
        <p className="mt-3 text-sm sm:text-base leading-7 text-gray-700">
          From humble beginnings to industry recognition, our journey has been a tapestry of challenges, breakthroughs,
          and late-night brainstorming sessions. We've weathered design storms, emerging stronger and more passionate.
        </p>
      </div>
    </section>
  );
};

export default ServicesStory;
